/**
 * ESM shim over the VENDORED parser/serializer.
 *
 * `kql.js` is copied BYTE-IDENTICAL from keepr-api (`utils/kql/kql.js`) and
 * must never be edited here — `vectors.json` (also byte-identical) is the
 * lock-step guarantee, driven by `__tests__/kql.vectors.test.js`. The vendored
 * file is CommonJS because the API runs it under Node; this shim is the only
 * thing standing between it and the app's ESM imports, so app code should
 * always `import { parse, serialize } from '../utils/kql'` and never reach for
 * `kql.js` directly.
 */
import kql from './kql';

export const {
	parse,
	serialize,
	KqlError,

	isHexId,
	isSystemField,
	systemFieldOf,
	facetKeyOf,
	isElementIdSegment,
	elementIdOf,
	elementIdSegment,
	elementIdsOf,
	conditionCount,
	usesMe,
	usesRef,
	refNamesOf,
	resolveRelativeDate,
	isRelativeLiteral,
	relativeGranularity,
	numberText,
	datePartOf,
	isCreatorPath,
	isSystemDatePart,
	datePartNumber,
	datePartValue,
	datePartSet,
	str,
	num,
	date,
	rel,
	bool,
	me,
	ref,
	list,
	cmp,
	facet,
	and,
	or,
	not,
	isBlock,
	blockOf,
	blockColumnOf,
	isEntryCountPath,
	block,
	has,

	MAX_QUERY_LENGTH,
	MAX_CONDITIONS,
	MAX_PATH_HOPS,
	MAX_PATH_SEGMENTS,
	SYSTEM_FIELDS,
	ME,
	FACET_CMPS,
	IDENT_RE,
	HEX_ID_RE,
	ELEMENT_ID_RE,
	REF_NAME_RE,
	TEMPLATE_NAMESPACES,
	RELATIVE_RE,
	RELATIVE_ANCHORED_RE,
	DATE_RE,
	DATETIME_RE,
	CMP_TEXT,
	VALUE_CMPS,
	LIST_CMPS,
	NULLARY_CMPS,
	BLOCK_CMP,
	BLOCK_VALUE,
	ENTRY_COUNT,
	DATE_PARTS,
	CREATOR_PART,
	PART_ROOTS,
	WEEKDAYS,
	MONTHS,
	DATE_PART_RANGE,
} = kql;

export default kql;
